import * as React from "react"
import { FormData, StepData, FieldData, DependencyData, DependenciesState, FormState } from "./types";
import { update_elem_in_list, update_field_AUX, are_dependencies_met, is_dependency_met, are_all_dependencies_met, DayPickerStrings, update_field_file } from "./utils";
import { AsyncState } from "widgets-for-react";
import { postFormSubmissionState } from "./api";
import { status_thank_you_renderer, status_sending_renderer, status_error_renderer } from "./status_message_renderers";
import * as moment from 'moment'
import { Stack, IStackStyles } from 'office-ui-fabric-react/lib/Stack';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { DatePicker } from 'office-ui-fabric-react/lib/DatePicker';
import * as i18next from 'i18next'
import { getVacancyIdFromUrl, parseParagraphs } from "../public_site/utils/helpers";
import { t } from 'i18next';
import Select from 'react-select'

export function parseRawHtml(input: string): HTMLElement {

  let elem = document.createElement('span')

  elem.innerHTML = input

  return elem

}

const debug = false

export let show_optional = (input: boolean) => {
  return (input
    ? ""
    : ' form__label--optional'
  )
}


export type fieldWidthsInput = "Large" | 'Medium' | 'Small' | 'Extra small'
export type fieldWidthsOutput = '' | ' form__group--m' | ' form__group--s' | ' form__group--xs'

export const fieldsWidth = (input: fieldWidthsInput) : fieldWidthsOutput  => {
  let output : fieldWidthsOutput =  '' 

  if(input == 'Extra small') {
    output = ' form__group--xs' 
  } else if(input == 'Small') {
    output = ' form__group--s'
  } else if(input == 'Medium') {
    output = ' form__group--m'
  }

  return output
}

export let dependency_renderer = (dependency: DependencyData, formState:FormState) =>
  <Stack horizontal horizontalAlign={"start"} gap={5}>
    <Text variant={'medium'}><b>Title</b>: {dependency.dependency.title}</Text>
    <Text variant={'medium'}><b>Is met?</b> {`${is_dependency_met(dependency.dependency, formState)}`}</Text>
    <Text variant={'medium'}><b>Hide if violated?</b> {`${dependency.dependency.hideIfViolated}`}</Text>
    <Text variant={'medium'}><b>Kind</b>: {dependency.dependency.Kind}</Text>
    <Text variant={'medium'}><b>Dependent fields</b>: {dependency.dependent_fields.map(df => `${df.FieldId}`).join(',')}</Text>
  </Stack>

export const stackStyles: IStackStyles = { root: { width: `100%`} };
export const stackStyles1: IStackStyles = { root: { width: `100%` } };

export let field_renderer = (field: FieldData, formState:FormState, update_field:(updated_field:FieldData, updatedDependencyState:DependenciesState) => void) =>
  { let isRequired = false
    if (formState.form_data.kind == 'loaded'){
      formState.form_data.value.steps.forEach(s => s.dependencies.forEach(d => d.dependent_fields.forEach(f => {if(f.FieldId == field.Id){ isRequired = true }})))
    }
    let are_dependencies_met_res = are_dependencies_met(field, formState)
    let default_selected_answer = field.maybe_answers.find(a => a.isDefaultSelected)
    const isVacancy = getVacancyIdFromUrl().v.kind == 'r'
    switch(field.Kind){

      case "RadioOption":
        return (
          <div className={`radio-btn form__group${fieldsWidth(field.width_percentage)}`}>
            <Label id={`field-${field.Id}`} className={`h3 form__label${show_optional(isRequired)}`}>
              {field.title}
              {isRequired ? '*' : ''}
            </Label>
            <div className="radio-btn__wrap">
              <ChoiceGroup
                defaultSelectedKey={default_selected_answer != undefined ? `answer-${default_selected_answer.Id}` : ""}
                options={
                    field.maybe_answers.map(a => ({
                      key: `answer-${a.Id}`,
                      text: a.value
                    }))
                }
                onChange={(_,selected_answer)=> {
                    if(field.Kind != 'RadioOption') return 
                    let res = update_field_AUX(field, selected_answer.text, formState)
                    update_field(res.fieldData, res.dependencyState)
                  }}
              />
            </div>
          </div>)

      case "Dropdown":
          return (
            <div className={`form__group${fieldsWidth(field.width_percentage)}`}>
              <Label id={`field-${field.Id}`} className={`h3 form__label${show_optional(isRequired)}`}>
              {field.title}
              {isRequired ? '*' : ''}
            </Label>
            <Select
              className="dropdown"
              options={
                !field.useExternalSource ? field.maybe_answers.map(a => ({
                  value: `answer-${a.Id}`,
                  label: a.value,
                  class: `dropdown__select`
                })) 
                : !formState.context.external_options.has(field.sourceName) ? [] 
                : formState.context.external_options.get(field.sourceName).map(a => ({
                    value: `answer-${a}`,
                    label: a,
                    class: `dropdown__select`
                  }))
              }
              onChange={(newValue, actionMeta) => {
                if(field.Kind != 'Dropdown') return 
                let res = update_field_AUX(field, newValue.label, formState)
                update_field(res.fieldData, res.dependencyState)
              }}
              placeholder={i18next.t("form:make_a_choice")}
            />
            </div>
          )

      case "Checkbox":

      
        return (
          <Stack className={`checkbox form__group${fieldsWidth(field.width_percentage)}${field.user_input != undefined && are_dependencies_met_res.kind == "no" ? ' form__group--error' : ''}`}>
            <div className="checkbox__wrap">

              <Checkbox
                id={"checkbox-" + field.Id}
                name={"checkbox-" + field.Id}
                defaultChecked={field.optionalDefaultValue.toLowerCase() == 'true'}
                onChange={(_, checked) => {
                  let res = update_field_AUX(field, `${checked ? true : ""}`.toLowerCase(), formState)
                  update_field(res.fieldData, res.dependencyState)
                }}
              >
              </Checkbox>
              <svg className="checkbox__checkmark" height="14" viewBox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg">
                <path d="m380 1834.96686 4.888931 6.03314 9.111069-12" fill="none" stroke="#FFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" transform="translate(-379 -1828)" />
              </svg>

              <label className="pseudo-label" htmlFor={"checkbox-" + field.Id} ><span className="ms-Checkbox-text" dangerouslySetInnerHTML={{ __html: field.title + (isRequired ? ' *' : '') }}></span></label>

              {
                field.user_input != undefined && are_dependencies_met_res.kind == "no"
                  ? <div className="alert">
                    <p className="ms-TextField-errorMessage error-message">
                      {are_dependencies_met_res.messages.join(" | ")}
                    </p>
                  </div>
                  : null
              }
              </div>
        </Stack>
         )

      case "CheckboxMultiSelect":
        return (
          <div className={`checkboxes form__group${fieldsWidth(field.width_percentage)}`}>
            <Label id={`field-${field.Id}`} className={`h3 form__label${show_optional(isRequired)}`}>
              {field.title}
              {isRequired ? '*' : ''}
            </Label>
            <div className="checkboxes__wrap">
              {field.maybe_answers.map(
                a => {
                  return <div className="checkboxes__item">
                      <Checkbox label={a.value} defaultChecked={a.isDefaultSelected} onChange={(_, selected_answer) => {
                      if (field.Kind != 'CheckboxMultiSelect') return
                      let res = null
                      if (selected_answer) {
                        res = update_field_AUX(field, field.user_input + "[" + a.value + "]", formState)
                      }
                      else {
                        res = update_field_AUX(field, field.user_input.replace("[" + a.value + "]", ""), formState)
                      }

                      update_field(res.fieldData, res.dependencyState)
                    }} />
                    <svg className="checkboxes__checkmark" height="14" viewBox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg">
                      <path d="m380 1834.96686 4.888931 6.03314 9.111069-12" fill="none" stroke="#FFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" transform="translate(-379 -1828)"/>
                    </svg>
                  </div>
                }
              )}
            </div>
          </div>
        )

      case "SimpleDate":
        return (
          <Stack className={`text-input form__group${fieldsWidth(field.width_percentage)}${field.user_input != undefined && are_dependencies_met_res.kind == "no" ? ' form__group--error' : ''}`}>
            <Label className={`h3 form__label${show_optional(isRequired)}`}>{field.title} {isRequired ? '*' : ''}</Label>
            <DatePicker firstDayOfWeek={1} strings={DayPickerStrings} placeholder={field.placeholder != undefined ? field.placeholder : ''} ariaLabel="Select a date"
              value={field.user_input === '' ? undefined : moment(field.user_input, 'DD-MM-YYYY').toDate()}
              minDate={field.StartDate as any == "" ? null : (typeof field.StartDate == "string" ? moment(field.StartDate).toDate() : field.StartDate.toDate())}
              isMonthPickerVisible={false}
              onSelectDate={new_date => {
                let res = update_field_AUX(field, moment(new_date, 'DD-MM-YYYY').format(), formState)
                update_field(res.fieldData, res.dependencyState)
              }} />
            {
              field.user_input != undefined && are_dependencies_met_res.kind == "no" 
                ? <div className="alert">
                    <p className="ms-TextField-errorMessage error-message">
                      {are_dependencies_met_res.messages.join(" | ")}
                    </p>
                  </div>
                : null
            }
          </Stack>
        ) 
      case "Attachement":
        let allowed_extensions = isVacancy ? ".doc,.docx,.pdf" : ".doc,.docx,.pdf,.jpg,.jpeg,.png"
        return (
          <Stack className={`attachment-field af form__group${fieldsWidth(field.width_percentage)}`}>
            <Label className={`h3 form__label${show_optional(isRequired)}`}>
              {field.title}
              {isRequired ? '*' : ''}
            </Label>
            {<input 
              accept={allowed_extensions}
              placeholder={field.placeholder != undefined ? field.placeholder : ""}
              className={`af__input${ field.user_input != undefined && are_dependencies_met_res.kind == "no" ? " form__input form__input--error" : "" }`}
              type="file"
              {...(isVacancy ? {} : { multiple: true })}
              onChange={(e:any) => {
                let files:FileList = (e.target as any).files
                if (isVacancy && files[0] != undefined) {
                  let file = files[0]
                  let extension = "." + (file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length) || file.name)
                  if (!allowed_extensions.includes(extension)) {
                    window.alert(i18next.t("form:accepted_file_types_text"))
                    e.preventDefault()
                    let res = update_field_file(field, null, "", formState)
                    update_field(res.fieldData, res.dependencyState)
                    return
                  }
                }
                if (isVacancy && files[0] == undefined) {
                  let res = update_field_file(field, null, "", formState)
                  update_field(res.fieldData, res.dependencyState)
                }
                else {
                  let res = update_field_file(field , files, files[0].name, formState)
                  update_field(res.fieldData, res.dependencyState)
                }
              }}
              />
            }
            {
              isVacancy ? 
                null :
                <p className="help-text">
                  To select multiple items, hold down the 'Command' key (for Mac) or 'Ctrl' key (for Windows) while clicking on the desired items.
                </p>
            }
            {
              (field.user_input != undefined && are_dependencies_met_res.kind == "no")
              ? <div className="alert">
                  <p className="ms-TextField-errorMessage error-message">{are_dependencies_met_res.messages.join(' | ').concat(field.user_input == "" && ` | ${i18next.t('form:accepted_file_types_text')}`)}</p>
                </div>
              : null
            }

          </Stack>
        ) 
      case "ReadonlyText":
        return (
          <Stack className={`form__group form__group--paragraph${fieldsWidth(field.width_percentage)} text--styled`}>
            <div dangerouslySetInnerHTML={{__html: parseParagraphs(field.Description)}}/>
          </Stack>
        )
      default:
        return (
          <Stack className={`text-input form__group${fieldsWidth(field.width_percentage)}${field.user_input != undefined && are_dependencies_met_res.kind == "no" ? ' form__group--error' : ''}`}>
            <Label className={`h3 form__label${show_optional(isRequired)}`}>{field.title} {isRequired ? '*' : ''}</Label>
            <TextField placeholder={field.placeholder != undefined ? field.placeholder : ""}
                        borderless
                        multiline={field.Kind == "TextArea"}
                        rows={field.Kind == "TextArea" ? 2 : null}
                        className={`form__input ${ field.user_input != undefined && are_dependencies_met_res.kind == "no" ? " form__input--error" : "" }`}
                        value={`${ field.user_input ? field.user_input : ""}`} 
                        onChange={(e,text) => {
                            let res = update_field_AUX(field , field.Kind == 'UserEmail' ? text.replace(/ /g, '') : text, formState)
                            update_field(res.fieldData, res.dependencyState)
                          }}
                          />  
                          {
                            field.user_input != undefined && are_dependencies_met_res.kind == "no" 
                            ? <div className="alert">
                                <p className="ms-TextField-errorMessage error-message">
                                {are_dependencies_met_res.messages.join(" | ")}
                                </p> 
                              </div>
                            : null
                           }
                           
          </Stack>
        ) 
    }
  }

function FillLabelContent(id, text) {
  var elem = document.getElementById('checkbox-' + id);
  elem.innerHTML = text;
}

export let step_renderer = (step: StepData, formState:FormState, update_step:(updated_step:StepData, updatedDependencyState:DependenciesState) => void) =>
  <Stack gap={20}>
    <Stack gap={10} className="form__wrap"> 
      {step.fields.sort((a,b) => a.itemOrderNumber < b.itemOrderNumber ? -1 : a.itemOrderNumber > b.itemOrderNumber ? 1 : 0).map((field, i) => field_renderer(field,
                                                    formState,
                                                    (field1, updated_dependencies) => 
                                                      update_step({...step, fields:update_elem_in_list(step.fields, i, field1)}, 
                                                                  updated_dependencies)))}
    </Stack>
    {
      debug 
      ? <Stack>
          <Text variant={'large'}> Dependencies: </Text>
          <Stack gap={10}>
            {step.dependencies.map(dependency => dependency_renderer(dependency, formState))}
          </Stack>
        </Stack>
        : null
    }
  </Stack>

// Set href so a hard load is done so Meta Pixel works properly: https://hoppinger.atlassian.net/browse/SREF-196
const redirectToSuccessPage = () => window.location.href = (window.location.href + (window.location.href.endsWith('/') ? '' : '/') + 'success/')

export let form_renderer = (data: FormData, formState:FormState, 
                                  update_form_submission_logic:(updated_form_submission_logic:AsyncState<string>) => void,
                                  update_form:(updated_form:FormData, updatedDependencyState:DependenciesState) => void) =>
  {
    if (formState.form_submission_logic.kind == 'loaded' &&
        formState.form_submission_logic.value == 'ok' &&
        formState.form_data.kind == 'loaded' &&
        data.form.title?.startsWith("vacancyapplication2")) 
    {
      redirectToSuccessPage()
      return <></>
    }

    return  <Stack styles={stackStyles} className="form">
      {formState.form_submission_logic.kind == 'loading' && status_sending_renderer()}
      {formState.form_submission_logic.kind == 'loaded' && 
        formState.form_submission_logic.value != 'ok' &&
        <p className="message message--error">{t(`form:${formState.form_submission_logic.value}`)}</p>
      }
      {formState.form_submission_logic.kind == 'loaded' && 
        formState.form_submission_logic.value == 'ok' && 
        formState.form_data.kind == 'loaded' &&
        status_thank_you_renderer(formState.form_data.value.thank_you.content)
      }
      {formState.form_submission_logic.kind == 'connection-error' && formState.form_submission_logic.retryCount >= 10 && status_error_renderer()}
      {formState.form_submission_logic.kind == 'loaded' && 
        formState.form_submission_logic.value == 'ok' && 
        formState.form_data.kind == 'loaded' ? null :
        <Stack className="form__inner" >
          <Stack  className="form__content" gap={20}>
            {data.steps.sort((a,b) => a.step.orderNumber < b.step.orderNumber ? -1 : a.step.orderNumber > b.step.orderNumber ? 1 : 0).map((step, i) => 
              step_renderer(step, 
                            formState,
                            (step1, updated_dependencies) => 
                              update_form({...data, steps:update_elem_in_list(data.steps, i, step1)}, 
                                          updated_dependencies)))}
          </Stack>
          <DefaultButton 
                onClick={() => {
                  update_form_submission_logic(postFormSubmissionState(data.form.Id, formState))
                }} 
                disabled={!are_all_dependencies_met(formState)} 
                text={i18next.t(data.form.title?.startsWith("vacancyapplication2") ? "applicationform:form_submit" : "form:form_submit")}
                type="button"
                className="form__button"/>
        </Stack>
      }
    </Stack>

}